export const DROPDOWN_SELECTED_EVENT = 'Dropdown Selected';
export const RADIOBUTTON_SELECTED_EVENT = 'Radio Button Selected';
export const FORM_ELEMENT_ANSWERED_EVENT = 'Form Element Answered';
export const BUTTON_CLICKED_EVENT = 'Button Clicked';
export const LINK_CLICKED_EVENT = 'Link Clicked';
